<app-base-modal
  title="You're up to date!"
  size="wide"
  titleColor="var(--color-evergreen)"
  closeIconColor="var(--color-evergreen)"
  [gradientBackground]="'linear-gradient(to bottom, var(--color-sundown), var(--color-parchment))'"
  (closed)="close()"
>
  <p class="update-complete-version">
    flip* has been updated to <strong>v {{ data.latestVersion }}</strong>
  </p>

  <ng-container *ngFor="let announcement of data.announcements">
    <ng-container *ngIf="announcement.newFeatures?.length || announcement.bugFixes?.length">
      <hr class="update-complete-divider" />

      <p class="update-complete-section-version" *ngIf="data.announcements.length > 1">
        v {{ announcement.version }}
      </p>

      <div class="update-complete-section" *ngIf="announcement.newFeatures?.length">
        <p class="update-complete-section-heading">New Features</p>
        <ul>
          <li *ngFor="let feature of announcement.newFeatures">{{ feature }}</li>
        </ul>
      </div>

      <div class="update-complete-section" *ngIf="announcement.bugFixes?.length">
        <p class="update-complete-section-heading">Bug Fixes</p>
        <ul>
          <li *ngFor="let fix of announcement.bugFixes">{{ fix }}</li>
        </ul>
      </div>
    </ng-container>
  </ng-container>

  <p class="update-complete-mobile-note" *ngIf="mobileUpdateNote === 'ios'">
    Using the flip* iPhone app? This update also requires you to update the app via TestFlight or the App Store.
  </p>
  <p class="update-complete-mobile-note" *ngIf="mobileUpdateNote === 'android'">
    Using the flip* Android app? This update also requires you to update the app via the Play Store.
  </p>

  <div actions>
    <button type="button" class="update-complete-close-pill" (click)="close()">
      Close
    </button>
  </div>
</app-base-modal>
